module.exports = __webpack_public_path__ + "static/media/pencil.48ceca71.png";